// extracted by mini-css-extract-plugin
export var noSpinners = "_ss-6";
export var percentageInput = "_ss-7";
export var variantColor1 = "_ss-0";
export var variantColor2 = "_ss-1";
export var variantColor3 = "_ss-2";
export var variantColor4 = "_ss-3";
export var variantColor5 = "_ss-4";
export var variantColor6 = "_ss-5";